const MENDELEEV_HOST = process.env.VUE_APP_API_HOST
const MENDELEEV_INSTANCE = String(process.env.VUE_APP_MENDELEEV_PREFIX).replace('/', '')

export {
  MENDELEEV_HOST,
  MENDELEEV_INSTANCE
}
